import ConfiguracionCuentas from '../views/Caja/ConfiguracionCuentas/ConfiguracionCuentas';
import ModalConfiguracionRecibos from '../views/Recibos/Configuracion/Modal';
import ModalConfiguraciones from '../views/Configuracion/Configuraciones/Modal';
import ModalCambiarFechaVencimiento from '../views/Configuracion/CambiarVencimiento/CambiarVencimiento.js';

export default {
	root: [{
		name: 'General',
		items: [
			{
				name: 'Ventas',
				icon: 'fa fa-handshake-o',
				items: [
                    {
                        name: 'Cobros',
                        url: '/cobros/',
                        permission: 'ventas_ventas_view'
                    },
                    {
                        name: 'Cobros Cuotas',
                        url: '/cuotaspagas/',
                        permission: 'ventas_consultas_view'
                    },
					{
						name: 'Ventas',
						url: '/ventas/',
						permission: 'ventas_ventas_view'
					},
					{
						name: 'Deudas',
						url: '/consultas/estadograldeudas/',
						permission: 'ventas_consultas_view'
					},

				]
			},
			{
				name: 'Servicios',
				icon: 'fa fa-handshake-o',
				items: [
					{
						name: 'Cobros',
						url: '/servicios/cobros/',
						permission: 'servicios_servicios_view'
					},
					{
						name: 'Cobros Cuotas',
						url: '/cuotaspagasse/',
						permission: 'ventas_consultas_view'
					},
					{
						name: 'Servicios',
						url: '/servicios/servicios/',
						permission: 'servicios_servicios_view'
					},
					{
						name: 'Deudas',
						url: '/servicios/deudas/',
						permission: 'ventas_consultas_view'
					},
				]
			},
			{
				name: 'Escrituras',
				icon: 'fa fa-handshake-o',
				items: [
                    {
                        name: 'Cobros',
                        url: '/escrituras/cobros/',
                        permission: 'escrituras_escrituras_view'
                    },
                    {
                        name: 'Cobros Cuotas',
                        url: '/cuotaspagases/',
                        permission: 'ventas_consultas_view'
                    },
					{
						name: 'Escrituras',
						url: '/escrituras/escrituras/',
						permission: 'escrituras_escrituras_view'
					},
					{
						name: 'Deudas',
						url: '/escrituras/deudas/',
						permission: 'ventas_consultas_view'
					},
				]
			},
			{
				name: 'Cuotas',
				icon: 'fa fa-globe',
				items: [
					{
						name: 'Ajustar Desactualizadas',
						url: '/cuotas/ajustar-desactualizadas/',
						permission: 'cuotas_ajustardesactualizadas_view'
					},
					{
						name: 'Actualizar Valores',
						url: '/cuotas/actualizar-valores/',
						permission: 'cuotas_actualizarvalores_view'
					},
				]
			},
			{
				name: 'Caja',
				icon: 'fa fa-money',
				items: [
					{
						name: 'Caja',
						url: '/caja/',
						permission: 'caja_caja_view'
					},
					{
						name: 'Movimientos',
						url: '/movimientoscaja/',
						permission: 'caja_movimientoscaja_view'
					},
                    // No funciona correctamente
					// {
					// 	name: 'Movimientos Reporte',
					// 	url: '/movimientosagrupados/',
					// 	permission: 'caja_movimientoscaja_view'
					// },
					{
						name: 'Cuentas',
						url: '/cuentas/',
						permission: 'caja_cuentas_view'
					},
					{
						name: 'Configuración',
						component: ConfiguracionCuentas,
						permission: 'caja_configuracioncuentas_view',
					},
				]
			},
			{
				name: 'Resumen',
				url: '/inversionistas/resumen/',
				permission: 'inversionista_ingresos'
			},
			{
				name: 'Consultas',
				icon: 'fa fa-comment',
				items: [
					{
						name: 'Consultas',
						icon: 'fa fa-comment',
						url: '/consultas/',
						permission: 'ventas_consultas_view'
					},
					{
						name: 'Reservas',
						url: '/reservas/',
						icon: 'fa fa-handshake-o',
						permission: 'ventas_reservas_view'
					},
				]
			},
			{
				name: 'Monedas',
				icon: 'fa fa-usd',
				items: [
					{
						name: 'Monedas',
						url: '/monedas/monedas/',
						permission: 'monedas_monedas_view'
					},
					{
						name: 'Historial',
						url: '/monedas/historial/',
						permission: 'monedas_historial_view'
					},
				]
			},
			{
				name: 'Recibos',
				icon: 'fa fa-file-pdf-o',
				items: [
					{
						name: 'Firmas',
						url: '/recibos/firmas/',
						icon: 'fa fa-pencil',
						permission: 'recibos_firmas_view'
					},
					{
						name: 'Configuración',
						component: ModalConfiguracionRecibos,
						icon: 'fa fa-cog',
						permission: 'recibos_configuracion_edit'
					},
				]
			},
			{
				name: 'Clientes',
				icon: 'fa fa-user',
				url: '/clientes/',
				permission: 'clientes_view'
			},
			{
				name: 'Gastos',
				url: '/obras/gastos/',
				icon: 'fa fa-money',
				permission: 'obras_gastos_view'
			},
			{
				name: 'Reportes',
				icon: 'fa fa-bar-chart',
				url: '/reportes/',
				permission: 'reportes_view'

			}, {
				name: 'Loteos',
				icon: 'fa fa-map-o',
				url: '/loteos/',
				permission: 'loteos_view'
			},
			{
				name: 'Proveedores',
				url: '/proveedores/',
				icon: 'fa fa-user',
				permission: 'proveedores_view'
			},
			{
				name: 'Obras',
				icon: 'fa fa-map-signs',
				url: '/obras/obras/',
				permission: 'obras_obras_view'
			},
			{
				name: 'Cuota Abierta',
				icon: 'fa fa-archive',
				url: '/escribanialist/',
				permission: 'escribania_view'
			},
			{
				name: 'Calendario',
				url: '/calendario/',
				icon: 'fa fa-calendar',
				permission: 'calendar_view'
			},
			{
				name: 'Usuarios',
				icon: 'fa fa-user',
				items: [{
					name: 'Usuarios',
					url: '/usuarios/usuarios/',
					icon: 'fa fa-user',
					permission: 'usuarios_view'
				}, {
					name: 'Permisos',
					url: '/usuarios/permisos/',
					icon: 'fa fa-lock',
					permission: 'superadmin'
				}, {
					name: 'Grupos',
					url: '/usuarios/grupos/',
					icon: 'fa fa-users',
					permission: 'grupos_view'
				}]
			},
			{
				name: 'Configuración',
				icon: 'fa fa-cog',
				items: [
					{
						name: 'Configuraciones',
						component: ModalConfiguraciones,
						icon: 'fa fa-cog',
						permission: 'config_edit'
					},
					{
						name: 'Cambiar Venc.Cuotas',
						component: ModalCambiarFechaVencimiento,
						icon: 'fa fa-cog',
						permission: 'config_edit'
					},
					{
						name: 'Registro Cambios',
						url: '/configuracion/registro/',
						icon: 'fa fa-cog',
						permission: 'config_edit'
					},
					{
						name: 'Encabezados',
						url: '/configuracion/encabezados/',
						icon: 'fa fa-header',
						permission: 'configuracion_encabezados_view'
					},
					{
						name: 'Rubros',
						url: '/configuracion/rubros/',
						icon: 'fa fa-th-list',
						permission: 'configuracion_rubros_view'
					},
					{
						name: 'Inversionistas',
						url: '/inversionistas/inversionistas/',
						icon: 'fa fa-user-circle',
						permission: 'configuracion_vendedores_view'
					},
					{
						name: 'Vendedores',
						url: '/vendedores/vendedores/',
						icon: 'fa fa-user-circle',
						permission: 'configuracion_vendedores_view'
					},
					{
						name: 'Tipos de Documento',
						url: '/configuracion/tiposdedocumento/',
						icon: 'fa fa-id-card-o',
						permission: 'configuracion_tiposdedocumento_view'
					},
					{
						name: 'Comprobante',
						url: '/configuracion/tiposdecomprobante/',
						icon: 'fa fa-file-text-o',
						permission: 'configuracion_tiposdecomprobante_view'
					},
					{
						name: 'Estado Civil',
						url: '/configuracion/estadocivil/',
						icon: 'fa fa-user-circle-o',
						permission: 'configuracion_tiposdedocumento_view'
					},
					{
						name: 'Tipos de Eventos',
						url: '/configuracion/tipoeventos',
						icon: 'fa fa-sticky-note-o',
						permission: 'tipo_eventos_view'
					},
					{
						name: 'Geográficas',
						icon: 'fa fa-globe',
						items: [
							{
								name: 'Localidades',
								url: '/geograficas/localidades/',
								permission: 'geograficas_localidades_view'
							},
							{
								name: 'Provincias',
								url: '/geograficas/provincias/',
								permission: 'geograficas_provincias_view'
							},
							{
								name: 'Nacionalidad',
								url: '/geograficas/nacionalidades/',
								permission: 'geograficas_provincias_view'
							},
							{
								name: 'Sucursales',
								url: '/geograficas/sucursales/',
								permission: 'geograficas_provincias_view'
							}
						]
					},
					{
						name: 'Mails',
						icon: 'fa fa-envelope-o',
						items: [
							{
								name: 'Casillas',
								url: '/configuracion/mails/casillas',
								permission: 'cm_casillas_view'
							},
							{
								name: 'Plantillas',
								url: '/configuracion/mails/plantillas',
								permission: 'cm_plantillas_view'
							},
							{
								name: 'Bitacora',
								url: '/mails/bitacora/',
							},
						]
					},
				]
			},
		]
	}]
};



// WEBPACK FOOTER //
// ./src/components/Menues.js